<script lang="ts">
export interface Props {
  messengerType?: string,
  messengerAddress?: string,
}
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<Props>(), {
  messengerType: '',
  messengerAddress: '',
});

const getMessengerLink = computed(() => {
  switch (props.messengerType) {
    case 'telegram':
      return `tg://resolve?domain=${props.messengerAddress}`;
    case 'skype':
      return `skype:${props.messengerAddress}?chat`;
    case 'viber':
      return `viber://chat?number=${props.messengerAddress}`;
    case 'whatsapp':
      return `https://api.whatsapp.com/send?phone=${props.messengerAddress.replace(/[^\d]/g, '')}`;
    case 'facebook':
      return `https://www.facebook.com/${props.messengerAddress}`;
    case 'instagram':
      return `https://www.instagram.com/${props.messengerAddress}`;
    case 'twitter':
      return `https://twitter.com/@${props.messengerAddress}`;
    case 'ms_teams':
      return props.messengerAddress;
    default:
      return '#';
  }
});

</script>

<template>
  <div
    :class="[
      'ui-messenger',
      `ui-messenger_${messengerType}`
    ]"
  >
    <a
      :href="getMessengerLink"
      rel="noopener noreferrer"
      target="_blank"
      class="ui-messenger__link"
    >
      {{ messengerAddress }}
    </a>
  </div>
</template>

<style lang="scss">
.ui-messenger {
  display: flex;
  align-items: center;
  overflow: hidden;

  &__link {
    color: var(--text-body);
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-decoration: none;
  }

  &:before {
    content: "";
    display: block;
    width: 14px;
    min-width: 14px;
    height: 14px;
    padding: 1px;
    margin-right: 4px;
  }
  &_telegram:before {
    background: url("@/assets/images/social/telegram-icon.svg") no-repeat center;
    background-size: cover;
  }
  &_skype:before {
    background: url("@/assets/images/social/skype-icon.svg") no-repeat center;
    background-size: cover;
  }
  &_viber:before {
    background: url("@/assets/images/social/viber-icon.svg") no-repeat center;
    background-size: cover;
  }
  &_whatsapp:before {
    background: url("@/assets/images/social/whatsapp-icon.svg") no-repeat center;
    background-size: cover;
  }
  &_facebook:before {
    background: url("@/assets/images/social/facebook-icon.svg") no-repeat center;
    background-size: cover;
  }
  &_instagram:before {
    background: url("@/assets/images/social/instagram-icon.svg") no-repeat center;
    background-size: cover;
  }
  &_twitter:before {
    background: url("@/assets/images/social/twitter-icon.svg") no-repeat center;
    background-size: cover;
  }
  &_ms_teams:before {
    background: url("@/assets/images/social/ms-teams.svg") no-repeat center;
    background-size: cover;
  }
}
</style>
